module.exports = __webpack_public_path__ + "img/emozioniRete.d76193cd.png";